module.exports = __webpack_public_path__ + "static/media/touch.00af89dc.mp3";